import { isEmptyObject } from "@config/utils";

const typenameProperties = {
    id: null,
    properties: [],
    property_id: null,
    property_name: null,
    property_title: null,
};

export default {
    defaultObj: {
    },
    data(){
        return {
            form: {},
            describeResourceProperties: [],
        }
    },
    computed: {
        isActive() {
            return  false;
        },
        disableField() {
            return this.readonlyForm || !this.hasResources || !this.isActive;
        },
    },
    methods: {
        resetDescribeResourceProperties() {
            this.describeResourceProperties = [];
        },
        async setDescribeResourceProperties(typename, force = false) {
            if(this.isActive) {
                if(this.describeResourceProperties.length == 0 || force) {
                    if(!typename) {
                        this.resetDescribeResourceProperties();
                    }
                    return await this.loadDescribeResource()
                    .then(data => {
                        this.assignResourcePropertiesToForm(typename, data ?? []);
                    })
                }
            }
        },
        assignResourcePropertiesToForm(typename = {}, dataResource = []) {
            if(isEmptyObject(typename)) {
                this.describeResourceProperties = dataResource;
                this.form.typenames = [];
            }
            dataResource.forEach(_typename => {
                if(!isEmptyObject(typename) && typename?.name != _typename.name) return;

                let typenameCfg = {
                    ..._typename,
                    ...JSON.parse(JSON.stringify(typenameProperties)),
                };

                (_typename?.properties ?? []).forEach((p, idx) => {
                    if(p?.schema_type?.startsWith("gml:")) return;

                    let propertiesCfg = {
                        source_id: p.id,
                        source_name: p.name,
                        source_type: p.type,
                        name: p.name,
                        type: p.type,
                        order: idx + 1,
                    };
                    typenameCfg.properties.push(propertiesCfg);
                });

                if(isEmptyObject(typename)) {
                    this.form.typenames.push(typenameCfg);
                }else{
                    let _idx = this.form.typenames.findIndex(item => item.name == _typename.name);
                    if(_idx > -1) {
                        this.form.typenames[_idx] = Object.assign(this.form.typenames[_idx], typenameCfg);
                    }
                }
            });
        },
        onResetProperties(typename) {
            this.setDescribeResourceProperties(typename, true);
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: function(value, oldValue){
                if(isEmptyObject(value)) {
                    this.form = Object.assign(this.form, {...(this.$options.defaultObj ?? {})});
                }else{
                    this.form = value;
                }
            }
        },
        form: {
            immediate: true,
            deep: true,
            handler: function(value, oldValue){
                this.$emit('input', value);
            }
        },
        selectedResource: {
            immediate: false,
            deep: true,
            handler: function(value, oldValue){
                if(value && value?.id != oldValue?.id) {
                    this.setDescribeResourceProperties()
                }
            }
        },
        isActive: {
            handler: function(value, oldValue){
                if(value != oldValue) {
                    this.setDescribeResourceProperties()
                }
            }
        },
    }
}